import { cn } from '../../lib/utils';

/**
 * Session badges. Resolution and feedback are separate fields on purpose — a
 * session can be resolved by the AI *and* rated negative, so they cannot share
 * one enum.
 */
const RESOLUTION_LABELS = {
  ai_resolved: 'Resolved by AI',
  escalated: 'Escalated',
  abandoned: 'Abandoned',
  pending: 'Pending',
};

const RESOLUTION_STYLES = {
  ai_resolved:
    'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-400 dark:border-emerald-500/30',
  escalated:
    'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-500/15 dark:text-amber-400 dark:border-amber-500/30',
  abandoned:
    'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-500/15 dark:text-slate-400 dark:border-slate-500/30',
  pending:
    'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-500/15 dark:text-slate-400 dark:border-slate-500/30',
};

export const ResolutionBadge = ({ state, className }) => (
  <span
    className={cn(
      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap',
      RESOLUTION_STYLES[state] || RESOLUTION_STYLES.pending,
      className
    )}
  >
    {RESOLUTION_LABELS[state] || 'Pending'}
  </span>
);

export const FeedbackBadge = ({ feedback, className }) => {
  if (!feedback || feedback === 'none') return null;
  const positive = feedback === 'positive';
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border',
        positive
          ? 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-400 dark:border-emerald-500/30'
          : 'bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-500/15 dark:text-rose-400 dark:border-rose-500/30',
        className
      )}
    >
      {positive ? 'Positive' : 'Negative'}
    </span>
  );
};

export const PriorityBadge = ({ priority, className }) => {
  const styles = {
    High: 'bg-destructive/10 text-destructive',
    Medium: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
    Low: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  };
  return (
    <span
      className={cn(
        'text-[10px] px-2 py-0.5 rounded uppercase font-bold tracking-wider',
        styles[priority] || styles.Low,
        className
      )}
    >
      {priority} Priority
    </span>
  );
};

export default ResolutionBadge;
